<template>
  <div class="modelcover">
    <div class="tips">
    	<div class="modal">
    		<div class="text-right">
    			<img src="../assets/img/closewin.png" style="cursor: pointer;" @click="handleCloseTips" >
    		</div>
    		<div class="text-center" style="font-size: 24px;margin-top: 30px;">
    			是否移除错题收藏
    		</div>
    		<div class="btnwrap flex" style="justify-content: center;margin-top: 100px;">
    			<span class="btn cancel" @click="handleCloseTips">否</span>
    			<span class="btn confirm" @click="handleRemove">是</span>
    		</div>
    	</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    components:{

    },
    data () {
      return {

      }
    },
    methods:{
      handleCloseTips(){
        this.$emit('handleCloseTips')
      },
      handleRemove(){
        this.$emit('handleRemove')
      }
    }
  }
</script>

<style scoped="">
  .modelcover {
    width: 100%;
        height: 100%;
        background-color: rgba(34, 34, 34, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        position: fixed;
        left: 0;
        z-index: 1988;
  }
  .modal {
  	width: 390px;
  	    height: 240px;
  	    border-radius: 10px;
  	    background-color: rgba(255, 255, 255, 1);
  	    position: relative;
  		padding: 30px;
  }
  .btnwrap .btn {
  	width: 150px;
  	height: 50px;
  	text-align: center;
  	line-height: 50px;
  	border-radius: 8px;
    cursor: pointer;
  }
  .cancel {
  	border: 1px solid #4fa7ff;
  	color: #4fa7ff;
  }
  .confirm {
  	background-color: #4fa7ff;
  	color: #fff;
  	margin-left: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/removetips.vue